import { render, staticRenderFns } from "./allBlog.vue?vue&type=template&id=22709b60&scoped=true"
import script from "./allBlog.vue?vue&type=script&lang=js"
export * from "./allBlog.vue?vue&type=script&lang=js"
import style0 from "./allBlog.vue?vue&type=style&index=0&id=22709b60&prod&scoped=true&lang=css"
import style1 from "./allBlog.vue?vue&type=style&index=1&id=22709b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22709b60",
  null
  
)

export default component.exports